var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 7.2H4.8C3.47665 7.2 2.4 8.27665 2.4 9.6V22.4C2.4 23.7234 3.47665 24.8 4.8 24.8H18.4C19.7234 24.8 20.8 23.7234 20.8 22.4V19.0223L27.0349 24.3908C27.2726 24.5955 27.6098 24.6428 27.8949 24.5114C28.18 24.38 28.3629 24.0941 28.3629 23.78V8.22003C28.3629 7.90588 28.18 7.61996 27.8949 7.48858C27.6098 7.35719 27.2726 7.40447 27.0349 7.60919L20.8 12.9777V9.6C20.8 8.27665 19.7234 7.2 18.4 7.2ZM19.2 22.4C19.2 22.8411 18.8411 23.2 18.4 23.2H4.8C4.3589 23.2 4 22.8411 4 22.4V9.6C4 9.1589 4.3589 8.8 4.8 8.8H18.4C18.8411 8.8 19.2 9.1589 19.2 9.6V22.4ZM26.7629 22.041L20.9509 17.0359C20.8639 16.9611 20.8 16.8482 20.8 16.7332V15.2668C20.8 15.1518 20.8639 15.0389 20.9509 14.9641L26.7629 9.95903V22.041Z",
    fill: "#2B70F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOutline);
export default __webpack_public_path__ + "static/media/video-outline.ef4e40470aa91d5099925faeae66827f.svg";
export { ForwardRef as ReactComponent };